if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || 
								Element.prototype.webkitMatchesSelector;
  }
  
  if (!Element.prototype.closest) {
	Element.prototype.closest = function(s) {
	  var el = this;
  
	  do {
		if (Element.prototype.matches.call(el, s)) return el;
		el = el.parentElement || el.parentNode;
	  } while (el !== null && el.nodeType === 1);
	  return null;
	};
  }

const toggleSlide = (el) => {
	console.log(el)
	const container = el.closest('.extra--content')
	const height = el.scrollHeight
	if (el.offsetHeight === 0) {
		el.style.maxHeight = height + 'px'
	}
	else {
		el.style.maxHeight = ""
	}
	container.classList.toggle('opened')
}